export const COLUMN_TYPE = ['nativeAd', 'companyPage'] as const;
export type ColumnType = (typeof COLUMN_TYPE)[number];

export const COLUMN_LIMITED_CONDITIONS = {
  LOGIN: '会員限定',
};

export const COLUMN_ARTICLE_TAG_REGEX = /\[article_set id="(\d+)"]/g;
export const COLUMN_ARTICLE_TAG_EMPTY_LI =
  /(<li class="text-base leading pl-20 w-1\/2 flex"><\/li>|<li><\/li>)/g;

export const COLUMN_COMPANY_STUDY_TAG_REGEX = /\[company_study id="(\d+)"]/g;
export const COLUMN_COMPANY_STUDY_TAG_EMPTY_LI =
  /(<li class="cs text-base leading pl-20"><\/li>|<li><\/li>)/g;
export const PARSE_COMPANY_STUDY_TAG_DATA_TYPE_SELECTION_REPORT =
  'selectionReport';
export const PARSE_COMPANY_STUDY_TAG_DATA_TYPE_ENTRY_SHEET = 'entrySheet';
